import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Meta Pixel Code
    const pixelId = '1153527106765702';
    // Initialize fbq function
    if (!window.fbq) {
      const fbq: any = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      window.fbq = fbq;
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
    }
    // Load the Facebook Pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Initialize pixel after script loads
    script.onload = () => {
      window.fbq('init', pixelId);
      window.fbq('track', 'PageView');
      window.fbq('track', 'ViewContent', {
        content_name: '30 Noches para Dormir en Paz',
        content_category: 'Digital Product',
        value: 9.97,
        currency: 'USD'
      });
    };
    // Cleanup
    return () => {
      // Remove script on unmount if needed
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return <noscript data-id="element-225">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1153527106765702&ev=PageView&noscript=1" alt="" data-id="element-226" />
    </noscript>;
}